var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 134.5 131.5",
    style: {
      enableBackground: "new 0 0 134.5 131.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1753FF;stroke:#1753FF;stroke-width:5;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.3,124.9c-8.1-0.1-16-2.7-23.6-6.4c-13.6-6.6-25.1-16-35.4-26.9c-8.8-9.3-16.4-19.5-21.8-31.3 c-2.8-6.1-4.8-12.3-5.4-19c-0.4-4.3-0.1-8.6,1.3-12.7c1.5-4.5,4.5-7.8,8.1-10.6c4-3,8.1-6,13-7.3c3.9-1.1,7.4-0.4,10.5,2.3 c5.2,4.5,9.5,9.7,12.9,15.7c2,3.5,2,6.9,0.1,10.5c-2.4,4.6-5.6,8.7-9.1,12.6c-0.9,1-0.9,1.7,0,2.7c10,12.3,21.1,23.4,33.4,33.4 c1,0.8,1.6,0.7,2.6-0.1c3.4-2.7,6.8-5.3,10.3-7.8c5-3.6,9.9-3.5,15,0c4.8,3.3,9.2,6.9,13.1,11.2c3.4,3.8,4,8,2.2,12.4 c-2.6,6.4-6.4,12.2-11.8,16.6C108.4,123.9,103.2,124.9,97.3,124.9z M97.8,118.4c5.8,0.1,10.9-1.6,14.4-6.6c2-2.9,4-5.8,5.7-8.9 c1.9-3.5,1.5-5.4-1.1-8.2c-3.6-3.9-7.7-7.2-12.3-10c-1.9-1.2-3.7-1.4-5.5-0.1c-3.6,2.6-7.3,5-10.7,7.8c-4.1,3.3-7.3,3.5-11.4,0.1 C64.5,82.3,53.2,71,43.1,58.6c-3.3-4.1-3.2-7.3,0.2-11.4c2.8-3.4,5.2-7,7.7-10.6c1.3-1.8,1.2-3.7,0-5.6c-2.9-4.6-6.4-8.7-10.2-12.6 c-2.2-2.2-4.4-2.2-7-1.2c-0.5,0.2-1,0.4-1.5,0.7c-2.7,1.7-5.5,3.4-8.1,5.3c-2.8,2-5.1,4.5-6,8c-0.8,3.1-1,6.2-0.7,9.3 c0.6,6.7,2.8,12.9,5.7,18.9c5.9,12.2,14.2,22.6,23.9,32c9.1,8.9,19.2,16.6,30.8,21.9C84.3,116.3,90.8,118.3,97.8,118.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.3,10.1C86.5,11.2,96.5,15,105.2,22c11.2,9.1,17.8,20.8,19.9,35.1c0.2,1.3,0.3,2.6,0.3,3.9 c0,1.8-1.2,3.1-2.9,3.3c-1.6,0.2-3.1-1-3.4-2.7c-0.5-2.7-0.7-5.5-1.3-8.2C113.7,35,98.1,20.3,79.6,17.3c-1.7-0.3-3.4-0.4-5.1-0.6 c-1.8-0.2-2.8-1.1-3.1-2.7c-0.2-1.2,0.4-2.6,1.5-3.2C73.7,10.4,74.6,10.3,75.3,10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.7,25.5c8.1,0.8,14.9,3.5,20.9,8.2c8.4,6.7,13.1,15.4,14.5,26c0.1,0.7,0.1,1.5-0.1,2.3 c-0.3,1.4-1.8,2.3-3.1,2.3c-1.5-0.1-2.6-1.1-3-2.6c-0.6-2.7-0.9-5.5-1.8-8.1c-4.7-12.5-13.7-19.7-27-21.5c-1.6-0.2-2.9-0.7-3.4-2.3 c-0.4-1.3-0.1-2.5,0.9-3.3C73.3,25.9,74.2,25.7,74.7,25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.8,60.8c0,1.8-1.1,3.2-2.8,3.4c-1.5,0.2-2.9-0.7-3.4-2.2c-0.3-1-0.4-2-0.8-3c-2.2-6.4-6.6-10.3-13.2-11.6 c-2.2-0.5-3.4-1.9-3.1-3.8c0.4-2,2-3,4.3-2.5c9.9,2,16.8,9,18.8,19C94.7,60.4,94.8,60.7,94.8,60.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.d40225392fe478da49b857ae375cfa4c.svg";
export { ForwardRef as ReactComponent };